import { Form, Input, InputNumber, Select } from "antd";
import React, { useEffect, useState } from "react";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import style from "./style.module.scss";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import { SimpleInput } from "../../../../common/components/simpleInput";
import {
  useQueryCraneMaterialTypeSelect,
  useQueryMachineMaterialEnergySelect,
  useQueryMachineMaterialFromSelect,
  useQueryMachineMaterialStateSelect,
} from "../../core/_hooks";
import { MaterialService } from "../../core/_request";
import { HttpStatusCode } from "axios";
import { InputSelect } from "../../../../common/components/InputSelect/InputSelect";
import { MaterialConstant } from "../../core/_constant";
import { API_URLs } from "../../../../utilities/API_URLs";
import { handleNumericDecimalInput } from "../../../../common/utils/numericInputHandler";

type PropsType = {
  onFinish: () => void;
  initialValue?: any;
};

export const GrueForm = ({ onFinish, initialValue }: PropsType) => {
  const [form] = Form.useForm();

  const { data: stateOptions, isLoading: isLoadingState } =
    useQueryMachineMaterialStateSelect();
  const { data: energyOptions, isLoading: isLoadingEnergy } =
    useQueryMachineMaterialEnergySelect();
  const { data: fromOptions, isLoading: isLoadingFrom } =
    useQueryMachineMaterialFromSelect();
  const { data: typeOptions, isLoading: isLoadingType } =
    useQueryCraneMaterialTypeSelect();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [selectedOwner, setSelectedOwner] = useState<any>("");

  useEffect(() => {
    if (initialValue) {
      setSelectedOwner(initialValue?.materialFrom?.id);

      form.setFieldsValue({
        ...initialValue,
        craneMaterialType: initialValue?.craneMaterialType
          ? {
              label: initialValue?.craneMaterialType?.name,
              value: initialValue?.craneMaterialType?.["@id"],
            }
          : null,
        materialEnergy: initialValue?.materialEnergy
          ? {
              label: initialValue?.materialEnergy?.name,
              value: initialValue?.materialEnergy?.["@id"],
            }
          : null,
        materialFrom: initialValue?.materialFrom
          ? {
              label: initialValue?.materialFrom?.name,
              value: initialValue?.materialFrom?.["@id"],
            }
          : null,
        materialState: initialValue?.materialState
          ? {
              label: initialValue?.materialState?.name,
              value: initialValue?.materialState?.["@id"],
            }
          : null,
        driver: initialValue?.driver
          ? {
              label: initialValue?.driver?.fullname,
              value: initialValue?.driver?.["@id"],
            }
          : null,
      });
    }
  }, [initialValue]);

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        ...values,
        ...(initialValue
          ? {
              "@id": initialValue?.["@id"],
            }
          : {}),
        capacity: values?.capacity?.toString(),
        craneMaterialType: values?.craneMaterialType
          ? values?.craneMaterialType?.value
          : null,
        materialEnergy: values?.materialEnergy
          ? values?.materialEnergy?.value
          : null,
        materialFrom: values?.materialFrom ? values?.materialFrom?.value : null,
        materialState: values?.materialState
          ? values?.materialState?.value
          : null,
        driver: values?.driver?.value ?? null,
      };

      if (!dataToPost?.id) {
        const res = await MaterialService.createGrueMaterial(dataToPost);

        if (res?.status === HttpStatusCode.Created) {
          onFinish();
          form?.resetFields();
        }
      } else {
        const res = await MaterialService.updateGrueMaterial(dataToPost);
        if (res?.status === HttpStatusCode.Ok) {
          onFinish();
          form?.resetFields();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
        </div>
        <div className={style.form}>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Référence"
                name={"reference"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<Input />}
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Capacité (T)"
                name={"capacity"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <InputNumber min={0} className={style.form__input} onKeyDown={handleNumericDecimalInput}/>
                }
              />
            </div>
          </div>

          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Propriétaire"
                name={"materialFrom"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Select
                    labelInValue
                    options={fromOptions}
                    loading={isLoadingFrom}
                    onChange={(e: any) => {
                      form.setFieldValue("driver", null);
                      setSelectedOwner(e?.key);
                    }}
                  />
                }
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Type"
                name={"craneMaterialType"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Select
                    labelInValue
                    options={typeOptions}
                    loading={isLoadingType}
                  />
                }
              />
            </div>
          </div>
          {selectedOwner === MaterialConstant.OWNER_TYPE.SEMS ? (
            <div className={style.form__item_wrapper}>
              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  label="Conducteur"
                  name={"driver"}
                  customInput={
                    <InputSelect
                      uri={API_URLs.staff.getStaffForSelect}
                      valueOption={{
                        labelKey: "fullname",
                        valueKey: "@id",
                      }}
                      params={{
                        staffPost: "CRANE_OPERATOR",
                      }}
                      onChange={(e) => console.log("aaaaa", e)}
                    />
                  }
                />
              </div>
            </div>
          ) : selectedOwner === MaterialConstant.OWNER_TYPE.COMAMA ? (
            <div className={style.form__item_wrapper}>
              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  label="Conducteur"
                  name={"comamaDriverName"}
                  customInput={<Input />}
                />
              </div>
            </div>
          ) : ""}
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Etat"
                name={"materialState"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Select
                    labelInValue
                    options={stateOptions}
                    loading={isLoadingState}
                  />
                }
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Energie"
                name={"materialEnergy"}
                customInput={
                  <Select
                    labelInValue
                    options={energyOptions}
                    loading={isLoadingEnergy}
                  />
                }
              />
            </div>
          </div>
        </div>
        <div className={style.form__action_wrapper}>
          <CustomButton
            type="submit"
            className={style.form__action_button}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};
